var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full h-full"},[_c('div',{staticClass:"bg-[#F9F9F9] fixed w-screen h-screen -z-50"}),_c('div',{staticClass:"py-12 px-8 flex flex-col lg:flex-row gap-[20px] w-full"},[_c('keep-alive',[_c('router-view')],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }